import type { Ring } from "@/api/types";

/** Rings that are never suggested: a tool on one is deprecated. */
export const RETIRED_RINGS: (Ring | null)[] = ["Hold", "Deprecated"];
